import { Icon } from "@iconify/react";
import Dashboard from "./Dashboard";
import PhoneBridge from "./PhoneBridge";
import OtherProviders from "./OtherProviders";
import ProviderView from "./OtherProviders/View";
import OtherIntegrations from "./OtherIntegrations";
import IntegrationView from "./OtherIntegrations/View";
import Support from "./Support";
import { SocketProvider } from "../../context/socket";

const routes = [
  {
    title: "Dashboard",
    icon: <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />,
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    icon: <Icon icon="solar:phone-outline" className="menu-icon" />,
    title: "Phone Bridge",
    key: "phone_bridge",
    route: "/phone_bridge",
    component: <PhoneBridge />,
  },
  {
    icon: <Icon icon="mdi:account-group-outline" className="menu-icon" />,
    title: "Conversation Providers",
    key: "conversation_providers",
    route: "/conversation_providers",
    component: <OtherProviders />,
  },
  {
    key: "conversation_providers/view/:locationId/:appId",
    route: "/conversation_providers/view/:appId",
    component: <ProviderView />,
  },
  {
    icon: <Icon icon="mdi:puzzle-outline" className="menu-icon" />,
    title: "Integrations",
    key: "integrations",
    route: "/integrations",
    component: <OtherIntegrations />,
  },
  {
    icon: <Icon icon="mdi:headset" className="menu-icon" />,
    title: "Support",
    key: "support",
    route: "/support",
    component: (
      <SocketProvider>
        <Support />
      </SocketProvider>
    ),
  },
  {
    key: "integrations",
    route: "/integrations/view/:appId",
    component: <IntegrationView />,
  },
];

export default routes;
